// Frontend entry point: wires Alpine.js (bundled from npm, not a CDN) and
// registers the small interactive stores/components the admin shell needs.
import Alpine from "alpinejs";
import { registerLiveFeed } from "./livefeed";
import { registerShell } from "./shell";

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

registerShell(Alpine);
registerLiveFeed(Alpine);

window.Alpine = Alpine;
Alpine.start();

// Public pay page language picker: navigate to ?lang=… on change. Kept here (external bundle) rather than an
// inline onchange so it runs even when a strict CSP blocks inline event handlers. Preserves path + other query.
document
  .querySelectorAll<HTMLSelectElement>("select[data-lang-switch]")
  .forEach((sel) => {
    sel.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("lang", sel.value);
      window.location.href = url.toString();
    });
  });
